import { render, staticRenderFns } from "./lrCheckbox.vue?vue&type=template&id=4217fa80"
import script from "./lrCheckbox.vue?vue&type=script&lang=js"
export * from "./lrCheckbox.vue?vue&type=script&lang=js"
import style0 from "./lrCheckbox.vue?vue&type=style&index=0&id=4217fa80&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports